export const defaultState = {
  lookup: {},
  userEducations: [],
  userExperiences: [],
  userLanguages: [],
  userDisabilities: [],
  userCertificates: [],
  userReferees: [],
  userPublications: [],
  userCV: "",
  userProfileStatus: {},
  rebApplicantPreferences: {},
};
